const AUTH_SERVER_URL = 'https://auth.documedias.com/';
const AUTH_SERVER_FRONTEND_KEY = process.env.VUE_APP_AUTH_SERVER_FRONTEND_KEY;

const PLANNER_API_URL = 'https://ecoc2025.planner.documedias.systems/api';
const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS = process.env.VUE_APP_CONGRESS;
const CONGRESS_ID = process.env.VUE_APP_CONGRESS_ID;

const SUBMISSION_API_URL = 'https://' + CONGRESS + '.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{ids}}/template/planner_preview';

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  PLANNER_API_KEY,
  CONGRESS,
  CONGRESS_ID,
  SUBMISSION_API_URL,
}
